module.exports = __webpack_public_path__ + "img/img11.341ac187.png";